import type { ToastContainerProps } from "react-toastify";
import { Slide } from "react-toastify";

export const TOAST_CONTAINER_PROPS: ToastContainerProps = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: "colored",
  toastStyle: { zIndex: 999_999 },
  style: { zIndex: 999_999 },
  bodyStyle: { zIndex: 999_999 },
  icon: false,
  closeButton: false,
  stacked: true,
  transition: Slide,
};
